import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { VideoClipperData } from '../../@types/video-clipper';

type Payload = {
  id: string;
  shouldFetchData?: boolean;
};

const getAiClipperById = async (payload: Payload): Promise<VideoClipperData> => {
  const res = await axiosInstance.get(`/api/video-clipper/${payload.id}`);
  return res.data;
};

export const useGetAiClipperById = (payload: Payload) => {
  return useQuery(
    ['getAiClipperById', payload.id],
    () => getAiClipperById(payload),
    {
      enabled: payload?.shouldFetchData !== false && !!payload.id,
      keepPreviousData: true,
    }
  );
};
